export default {"src":"/_next/static/media/ms-teams-logo.6a37298d.svg","height":49,"width":48,"blurWidth":0,"blurHeight":0};